import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import MeInstoreOnlyOfferDetails from './components/MeInstoreOnlyOfferDetails';

import config from './configs';

import './MeInstoreOnlyOffer.scss';

function MeInstoreOnlyOffer({ offer }) {
  const { isLoaderInverted } = config;

  return (
    <div className="mn_meInstoreOnlyOffer">
      <ContentWrap>
        <MeInstoreOnlyOfferDetails offer={offer} isLoaderInverted={isLoaderInverted} />
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><MeInstoreOnlyOffer {...props} /></ComponentErrorBoundary>;
